import permissionService from '@services/permissionService';

export default {
  methods: {
    hasProviderId() {
      return permissionService.hasProviderId();
    },
    isAdmin() {
      return permissionService.isAdmin();
    },
    isGas() {
      return permissionService.isGas();
    },
    isGav() {
      return permissionService.isGav();
    },
    isGasGav() {
      return permissionService.isGasGav();
    },
    isOwner() {
      return permissionService.isOwner();
    },
    isDeveloper() {
      return permissionService.isDeveloper();
    },
    isPrestataire() {
      return permissionService.isPrestataire();
    },
    isPartenaire() {
      return permissionService.isPartenaire();
    },
    isHousekeeper() {
      return permissionService.isHousekeeper();
    },
    isCommercial() {
      return permissionService.isCommercial();
    },
    isMe(userId) {
      return permissionService.isMe(userId);
    },
    hasPermission(permission) {
      return permissionService.hasPermission(permission);
    },
    hasOneOfThem(permissions) {
      return permissionService.hasOneOfThem(permissions);
    },
    myUserId() {
      return permissionService.myUserId();
    },
    myEmployeeId() {
      return permissionService.myEmployeeId();
    },
    myCompanyId() {
      return permissionService.myCompanyId();
    },
    myOwnerId() {
      return permissionService.myOwnerId();
    },
    myPartenaireId() {
      return permissionService.myPartenaireId();
    },
    myHousekeeperId() {
      return permissionService.myHousekeeperId();
    },
    myCommercialId() {
      return permissionService.myCommercialId();
    },
    isPoleComptabiliteMandante() {
      return permissionService.isPoleComptabiliteMandante();
    },
    isGasGavOrCommercial() {
      return permissionService.isGasGav() || permissionService.isCommercial();
    },
    myUserDisplay() {
      let userInfo = permissionService.myUserInformation();
      return userInfo.firstName + ' ' + userInfo.lastName;
    },
  },
};
